exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg-icon[data-v-c8a70580][data-v-f142be86] {\n  width: 19px;\n  height: 19px;\n}\n", ""]);

// exports
